import { BaseGet } from './BaseData';
import { appSettings } from '../AppSettings';

export type User = {
  userId: string;
  userName: string;
};

export type Permissions = {
  hasAdminAccess: boolean;
  hasDecryptForeignHashesAccess: boolean;
  hasGreenSideViewAccess: boolean;
  hasGreenSideWriteAccess: boolean;
  hasSampleTrackingViewAccess: boolean;
  hasSampleTrackingWriteAccess: boolean;
  hasSuperDuperFiestaAccess: boolean;
  hasSuperDuperFiestaAdminAccess: boolean;
  hasSampleTrackingAdminAccess: boolean;
  hasRedSideAccess: boolean;
};

export const emptyPermissions = {
  hasAdminAccess: false,
  hasDecryptForeignHashesAccess: false,
  hasGreenSideViewAccess: false,
  hasGreenSideWriteAccess: false,
  hasSampleTrackingViewAccess: false,
  hasSampleTrackingWriteAccess: false,
  hasSuperDuperFiestaAccess: false,
  hasSuperDuperFiestaAdminAccess: false,
  hasSampleTrackingAdminAccess: false,
  hasRedSideAccess: false,
};

export type UserPermissionsData = {
  user: User;
  permissions: Permissions;
};

export async function GetPermissions(accessToken: string): Promise<UserPermissionsData> {
  return await BaseGet(`${appSettings.api.endpoint}/api/v2/Permission`, accessToken);
}
